module.exports = __webpack_public_path__ + "static/media/found.d83a95d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/found.svg
// module id = 171
// module chunks = 0